export const API_ROOT = window.__env.API_ROOT
export const BASE_URL = window.__env.BASE_URL
export const POINTS_CURRENCY_ID = window.__env.POINTS_CURRENCY_ID
export const POINTS_SERVICE_CODE = window.__env.POINTS_SERVICE_CODE
export const PANEL_LOCATION = window.__env.PANEL_LOCATION
export const MISC_ACCOUNT_ID = window.__env.MISC_ACCOUNT_ID
export const DAYPASS_SERVICE_CODE = window.__env.DAYPASS_SERVICE_CODE
export const EXTENSION_API_ROOT = window.__env.EXTENSION_API_ROOT
